import styled from 'styled-components';

const ModalForm = styled.form`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(510px, calc(100vw - 30px));
  max-height: calc(100vh - 30px);
  overflow-y: auto;
  background-color: #fff;
  padding: 25px;
  border-radius: 40px 40px 40px 0px;
`;

const ModalActions = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 28px;
`;

const TranslationStatusPanel = styled.div`
  background: ${(p) => p.theme.colors.gray000};
  border-left: 4px solid ${(p) => p.theme.colors.primary500};
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.base};
  line-height: 1.5;
  padding: 20px;

  &[data-status='succeeded'] { border-left-color: ${(p) => p.theme.colors.success}; }
  &[data-status='failed'],
  &[data-status='expired'] { border-left-color: ${(p) => p.theme.colors.danger}; }
`;

const ModalTitle = styled.div`
  font-size: ${(p) => p.theme.fontSizes.md};
  font-weight: 700;
  color: ${(p) => p.theme.colors.gray500};
  margin-bottom: 15px;
`;

const ModalNotice = styled.div`
  font-size: ${(p) => p.theme.fontSizes.base};
  color: ${(p) => p.theme.colors.red};
  margin-bottom: 15px;
`;

const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0 20px 0;
`;

const ProgressMessage = styled.p`
  font-size: ${(p) => p.theme.fontSizes.sm};
  color: ${(p) => p.theme.colors.gray400};
`;

const ProgressBarContainer = styled.div`
  width: 100%;
  max-width: 460px;
  margin-top: 50px;
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 10px;
  background: #e9e9e9;
  border-radius: 5px;
  overflow: hidden;

  > div {
    height: 100%;
    background: ${(p) => p.theme.colors.secondary500};
    border-radius: 5px;
    transition: width 0.3s ease;
  }
`;

const ProgressText = styled.div`
  text-align: center;
  font-size: ${(p) => p.theme.fontSizes.sm};
  color: ${(p) => p.theme.colors.gray400};
  margin-top: 10px;
  margin-bottom: 64px;
`;

const SuccessIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 35px;
`;

const SuccessText = styled.div`
  font-size: ${(p) => p.theme.fontSizes.base};
  font-weight: 500;
  color: ${(p) => p.theme.colors.success};
  text-align: center;
  margin-top: 15px;
`;

const ErrorText = styled.div`
  font-size: ${(p) => p.theme.fontSizes.base};
  font-weight: 500;
  color: ${(p) => p.theme.colors.danger};
  text-align: center;
  margin-top: 15px;
`;

export {
  ModalForm,
  ModalTitle,
  ModalNotice,
  ModalActions,
  TranslationStatusPanel,
  ProgressContainer,
  ProgressMessage,
  ProgressBarContainer,
  ProgressBar,
  ProgressText,
  SuccessIcon,
  SuccessText,
  ErrorText
};
